import React from 'react'

import { string, number } from 'prop-types'

import formatPrice from 'Utils/formatPrice'

function CollectionItem({
  thumbnail, title, itemsCount, collectionPrice, saleOffDiscount, url,
}) {
  const finalPrice = () => {
    if (saleOffDiscount > 0) {
      return collectionPrice - (collectionPrice * saleOffDiscount / 100)
    }
    return collectionPrice
  }

  const handleRedirect = () => {
    if (url) {
      window.location.href = url
    }
  }

  return (
    <div className="details-area__collection" onClick={handleRedirect}>
      <img src={thumbnail} alt="item" className="details-area__collection-image" />
      <div className="details-area__collection-info">
        <div className="details-area__collection-info-top">
          <span className="details-area__collection-name">{title}</span>
          <div className="details-area__collection-items">{itemsCount} item{itemsCount > 1 ? 's' : ''}</div>
        </div>
        <div className="details-area__collection-price-info">
          {saleOffDiscount > 0 && (
            <span className="details-area__models-price">{formatPrice(collectionPrice)}</span>
          )}
          <span className="details-area__collection-price">{formatPrice(finalPrice())}</span>
        </div>
      </div>
    </div>
  )
}

CollectionItem.propTypes = {
  collectionPrice: number.isRequired,
  itemsCount: number.isRequired,
  saleOffDiscount: number.isRequired,
  thumbnail: string.isRequired,
  title: string.isRequired,
  url: string.isRequired,
}

export default CollectionItem
